export default [
    {
        header: 'Занятия',
        visibleFor: ['all'],
    },
    {
        title: 'Предметы',
        icon: 'BookIcon',
        tagVariant: 'light-warning',
        route: 'subjects',
        visibleFor: ['student'],
    },
    {
        title: 'Расписание',
        icon: 'CalendarIcon',
        tagVariant: 'light-warning',
        route: 'schedule',
        visibleFor: ['student'],
    },
    {
        title: 'Азбука 1',
        icon: 'HelpCircleIcon',
        tagVariant: 'light-warning',
        route: 'letter-1',
        visibleFor: ['student'],
    },
    {
        title: 'Азбука 2',
        icon: 'HelpCircleIcon',
        tagVariant: 'light-warning',
        route: 'letter-2',
        visibleFor: ['student'],
    },
    {
        title: 'Слова',
        icon: 'HelpCircleIcon',
        tagVariant: 'light-warning',
        route: 'words',
        visibleFor: ['student'],
    },
    {
        title: 'Тест',
        icon: 'HelpCircleIcon',
        tagVariant: 'light-warning',
        route: 'tests',
        visibleFor: ['student'],
    },
    {
        title: 'Техническая поддержка',
        icon: 'HelpCircleIcon',
        tagVariant: 'light-warning',
        route: 'support',
        visibleFor: ['student'],
    },
    {
        title: 'Личные данные',
        icon: 'UserIcon',
        tagVariant: 'light-warning',
        visibleFor: ['student'],
        children: [
            {
                title: 'Личные данные',
                route: 'personal',
                tagVariant: 'light-warning',
                visibleFor: ['student'],
            },
            {
                title: 'Пароль',
                route: 'password',
                tagVariant: 'light-warning',
                visibleFor: ['student'],
            },
        ]
    },
    /*{
        title: 'База знаний',
        icon: 'DatabaseIcon',
        tagVariant: 'light-warning',
        route: 'know.base',
        visibleFor: ['student'],
    },*/
    {
        title: 'Запланировать вебинар',
        icon: 'DatabaseIcon',
        tagVariant: 'light-warning',
        route: 'schedule.webinar',
        visibleFor: ['teacher'],
    },
    {
        title: 'Предстоящие вебинары',
        icon: 'DatabaseIcon',
        tagVariant: 'light-warning',
        route: 'webinars',
        visibleFor: ['teacher'],
    },
    {
        title: 'Проверка домашнего задания',
        icon: 'DatabaseIcon',
        tagVariant: 'light-warning',
        route: 'homework.check',
        visibleFor: ['teacher'],
    },
    {
        title: 'Мои дети',
        icon: 'UsersIcon',
        tagVariant: 'light-info',
        route: 'parental-control.dashboard',
        visibleFor: ['parent'],
    },
    {
        title: 'Admin CRM',
        icon: 'DatabaseIcon',
        visibleFor: ['admin'],
        children: [
            {
                title: 'Программа обучения',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
                children: [
                    {
                        title: 'Предметы',
                        route: 'admin.subjects',
                        tagVariant: 'light-warning',
                        visibleFor: ['admin'],
                    },
                    {
                        title: 'Программы',
                        route: 'admin.programs',
                        tagVariant: 'light-warning',
                        visibleFor: ['admin'],
                    },
                    {
                        title: 'Уроки',
                        route: 'admin.lessons',
                        tagVariant: 'light-warning',
                        visibleFor: ['admin'],
                    },
                    {
                        title: 'Тесты',
                        route: 'admin.tests',
                        tagVariant: 'light-success',
                        visibleFor: ['admin'],
                    },
                    {
                        title: 'Родительский контроль',
                        route: 'admin.parental-control',
                        tagVariant: 'light-info',
                        visibleFor: ['admin'],
                    },
                ]
            },
            {
                title: 'Пробные уроки',
                route: 'admin.trial',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Балансы',
                route: 'admin.balances',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Вебинары',
                route: 'admin.webinars',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Переводы',
                route: 'admin.transactions',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Время работы учителей',
                route: 'admin.teacher-schedule',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Студенты',
                route: 'admin.student',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Движения по счетам',
                route: 'admin.payments',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Группы',
                route: 'admin.teacher.groups',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Зачисление денег',
                route: 'admin.teacher.transfer',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
            {
                title: 'Группы',
                route: 'admin.groups',
                tagVariant: 'light-warning',
                visibleFor: ['admin'],
            },
        ]
    }
]
